import Helper from '@ember/component/helper';

// https://github.com/romulomachado/ember-cli-string-helpers/blob/master/addon/utils/titleize.js
export function titleize([string] = [''], { lowercase } = { lowercase: false }) {
  if (typeof string !== 'string') {
    throw new TypeError(`Expected a string, got a ${typeof string}`);
  }

  if (lowercase) {
    string = string.toLowerCase();
  }

  return string.replace(/_/g, '-').replace(/(?:^|\s|-|\/)\S/g, (m) => m.toUpperCase());
}

/*
  Basic Usage:

  ```handlebars
  {{titleize model.firstName}}
  ```
*/
export default Helper.helper(titleize);
